import { CommonModule, Location } from  '@angular/common';
import { Component, OnInit, ComponentDecorator, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '@app/layout/layout.service';


@Component({
  selector: 'app-bar',
  templateUrl: './appbar.component.html',
  styleUrls: ['./appbar.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class AppbarComponent  implements OnInit {

  @Input() back: boolean;
  // @Input() margin: boolean = true;
  @Input() route: string;
  @Input() icon: string;
  @Input() title = '';

  public movil = true;

  constructor(
    public layoutService: LayoutService,
    private router: Router,
    private location: Location,
  ) {
  }

  ngOnInit() {}

  toggleNavigation(): void {
    this.layoutService.hovered.next(!this.layoutService.hovered.value);
  }

  goToRoute() {
    if (this.back) {
      this.location.back();
    }
    else {
      this.router.navigate([this.route]);
    }
  }

}
